import React from 'react';
import classes from './VerticalSpace.module.scss';

export function VerticalSpace() {
  return <div className={classes.root} />;
}
